import { NavBar, Toast, Button, Dialog, Empty } from 'antd-mobile'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import './style.css'
import { seasonApi } from '../../features/season/api/seasonApi';

export default function CustomSeason() {

  const [seasonList, setSeasonList] = useState([])
  const navigate = useNavigate()

  const getSeasonListInfo = useCallback(() => {
    Toast.show({
      icon: 'loading',
      duration: 0
    })
    seasonApi.getList()
      .then(function (response) {
        setSeasonList(response.data.data);
        Toast.clear()
      })
      .catch(function (error) {
        Toast.show({
          icon: 'fail',
          content: "服务错误！请联系管理员！"
        })
      })
      .finally(() => {
      });
  }, [])


  const formatDate = (date) => {
    const dateInfo = new Date(date)
    const year = dateInfo.getFullYear();
    const month = String(dateInfo.getMonth() + 1).padStart(2, '0');
    const day = String(dateInfo.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    getSeasonListInfo()
  }, [getSeasonListInfo]);

  const handleSetCurrentSeason = (season) => {
    Dialog.confirm({
      title: "当前赛季",
      content: season.isFirst === 1 ? '该赛季已经是当前赛季，是否重新确认设置？' : '是否设置为当前赛季',
      onConfirm: () => {
        const formData = new FormData();
        formData.append('id', season.id);
        seasonApi.setCurrent(formData)
          .then(function (response) {
            const result = response.data
            if (result.code === 200) {
              Toast.show({
                icon: 'success',
                content: "修改成功！"
              })
              getSeasonListInfo()
            } else {
              Toast.show({
                icon: 'fail',
                content: result.msg
              })
            }

          })
          .catch(function () {
            Toast.show({
              icon: 'fail',
              content: "系统错误！请联系管理员",
            })
          })
          .finally(() => {
          });
      }
    });
  }

  const getSeasonDays = (startDate, endDate) => {
    const start = new Date(startDate).getTime()
    const end = new Date(endDate).getTime()
    if (!start || !end) return '--'
    return Math.max(1, Math.ceil((end - start) / (24 * 60 * 60 * 1000)) + 1)
  }

  // 当前赛季用于顶部概览展示，不改变原有设置当前赛季的接口逻辑。
  const currentSeason = seasonList?.find(item => item.isFirst === 1)

  return (
    <div className='custom-season-container season-page has-unified-nav ui-page ui-page--with-nav'>
      <NavBar
        className="unified-navbar fixed"
        onBack={() => window.history.back()}
      >
        赛季管理
      </NavBar>
      <div className='body_detail season-body ui-page__content'>
        <section className="season-hero">
          <div className="season-hero-label">HUAXI SOCCER SEASON</div>
          <div className="season-hero-title">赛季管理中心</div>
          <div className="season-hero-desc">维护球队赛季周期，设置当前赛季后会影响榜单、报名与数据统计。</div>
          <div className="season-hero-stats">
            <div>
              <strong>{seasonList?.length || 0}</strong>
              <span>赛季总数</span>
            </div>
            <div>
              <strong>{currentSeason?.seasonName || '未设置'}</strong>
              <span>当前赛季</span>
            </div>
          </div>
        </section>

        <div className="season-toolbar">
          <div>
            <strong>赛季列表</strong>
            <span>按赛季时间管理球队数据</span>
          </div>
          <Button className="season-add-btn" onClick={() => navigate('/SeasonInsert')}>
            添加赛季
          </Button>
        </div>

        {seasonList?.length ? (
          <div className="season-list">
            {seasonList?.map((season) =>
              <section className={`season-card ${season.isFirst === 1 ? 'active' : ''}`} key={season.id}>
                <div className="season-card-main">
                  <div className="season-card-top">
                    <span className="season-badge">{season.isFirst === 1 ? '当前赛季' : '历史赛季'}</span>
                    <span className="season-days">{getSeasonDays(season.startDate, season.endDate)} 天</span>
                  </div>
                  <div className="season-name">{season.seasonName}</div>
                  <div className="season-date">
                    <span>{formatDate(season.startDate)}</span>
                    <i></i>
                    <span>{formatDate(season.endDate)}</span>
                  </div>
                </div>
                <div className="season-actions">
                  {/* 设置当前赛季改为胶囊按钮，避免系统开关出现突兀边框。 */}
                  <button
                    className={`season-current-btn ${season.isFirst === 1 ? 'active' : ''}`}
                    onClick={() => handleSetCurrentSeason(season)}
                  >
                    {season.isFirst === 1 ? '使用中' : '设为当前'}
                  </button>
                  <Button
                    className="season-delete-btn"
                    size='small'
                    onClick={() => {
                      Dialog.confirm({
                        title: "确认删除",
                        onConfirm: () => {
                          const formData = new FormData();
                          formData.append('id', season.id);
                          seasonApi.delete(formData)
                            .then(function (response) {
                              const result = response.data
                              if (result.code === 200) {
                                Toast.show({
                                  icon: 'success',
                                  content: "删除成功！"
                                })
                                getSeasonListInfo()
                              } else {
                                Toast.show({
                                  icon: 'fail',
                                  content: result.msg
                                })
                              }
                            })
                            .catch(function () {
                              Toast.show({
                                icon: 'fail',
                                content: "系统错误！请联系管理员",
                              })
                            })
                            .finally(() => {
                            });

                        }
                      });
                    }}
                  >
                    删除
                  </Button>
                </div>
              </section>
            )}
          </div>
        ) : (
          <div className="season-empty">
            <Empty description='暂无赛季数据' />
            <Button className="season-empty-btn" onClick={() => navigate('/SeasonInsert')}>创建第一个赛季</Button>
          </div>
        )}
      </div>

    </div>
  )
}
